// ViewLeave.jsx
import React from "react";
import styles from "./ViewLeave.module.css";
import { useSelector, useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";
import ToClose from "../../components/ToClose/ToClose";

const ViewLeave = () => {
  const dispatch = useDispatch();
  const leave = useSelector((state) => state.leave.selectedLeave);

  if (!leave) return null;

  const getDaysBetween = (from, to) => {
    if (!from || !to) return "Invalid Dates";
    const start = new Date(from);
    const end = new Date(to);
    const diff = Math.ceil((end - start) / (1000 * 3600 * 24)) + 1;
    return diff > 0 ? `${diff} Days` : "Invalid Dates";
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <p>Leave Details</p>
        <ToClose onClose={() => dispatch(closeModal())} />
      </div>
      <div className={styles.body}>
        <div className={styles.row}>
          <div>
            <label>From</label>
            <input type="text" value={leave.fromDate || "-"} readOnly />
          </div>
          <div>
            <label>Type</label>
            <input type="text" value={leave.leaveType || "-"} readOnly />
          </div>
        </div>

        <div className={styles.row}>
          <div>
            <label>To</label>
            <input type="text" value={leave.toDate || "-"} readOnly />
          </div>
          <div>
            <label>Days</label>
            <input
              type="text"
              value={getDaysBetween(leave.fromDate, leave.toDate)}
              readOnly
            />
          </div>
        </div>

        <div className={styles.reasonBox}>
          <label>Reason</label>
          <textarea value={leave.reason || "-"} readOnly />
        </div>

        <div className={styles.footer}>
          <button className={styles.denyButton}>Deny</button>
          <button className={styles.approveButton}>Approve</button>
        </div>
      </div>
    </div>
  );
};

export default ViewLeave;
